import { gsap, ScrollTrigger } from "@/composeables/gsap";

export const init = () => {

    const mapSections = gsap.utils.toArray(".section-map");

    mapSections.forEach(function(mapSection){

        const tiles = mapSection.querySelectorAll(".contact-card-container");

        if (!tiles.length) return;

        gsap.set(tiles, { autoAlpha: 0, y: "60px" });

        ScrollTrigger.batch(tiles, {
            interval: 0.1,
            batchMax: 6,
            invalidateOnRefresh: true,
            start: "center bottom",
            onEnter: batch => gsap.to(batch, {
                autoAlpha: 1,
                y: 0,
                stagger: 0.12,
                overwrite: true,
                ease: "expo.out",
                duration: 1,
            }),
        });

    });
}

export default init;
